module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBold.333c24b2.eot";